export default __webpack_public_path__ + "static/media/Lato-BlackItalic.8b75b50d.ttf";